import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "questionType",
    "multipleChoiceOptions",
    "trueFalseOptions",
    "shortAnswerOptions",
    "optionsContainer",
  ];

  connect() {
    const existingOptions =
      this.optionsContainerTarget.querySelectorAll("[data-option]");

    if (existingOptions.length > 0) {
      this.optionCounter =
        Math.max(
          ...Array.from(existingOptions).map(
            (el) => parseInt(el.dataset.option, 10) || 0
          )
        ) + 1;
    } else {
      this.optionCounter = 0;
      this.addInitialOptions();
    }

    this.toggleAnswerSections();
  }

  toggleAnswerSections() {
    const selectedType = this.questionTypeTarget.value;

    this.multipleChoiceOptionsTarget.classList.add("hidden");
    this.trueFalseOptionsTarget.classList.add("hidden");
    this.shortAnswerOptionsTarget.classList.add("hidden");

    if (selectedType === "multiple_choice") {
      this.multipleChoiceOptionsTarget.classList.remove("hidden");
    } else if (selectedType === "true_false") {
      this.trueFalseOptionsTarget.classList.remove("hidden");
    } else if (selectedType === "short_answer") {
      this.shortAnswerOptionsTarget.classList.remove("hidden");
    }
  }

  addOption() {
    const optionWrapper = document.createElement("div");
    optionWrapper.className = "flex items-start space-x-2 mb-3";
    optionWrapper.dataset.option = this.optionCounter;

    optionWrapper.innerHTML = `
      <div class="pt-1">
        <input type="checkbox" name="quiz_question[options_correct][]" id="option_correct_${this.optionCounter}" 
               value="${this.optionCounter}" class="h-4 w-4 text-indigo-600 rounded">
      </div>
      <div class="flex-grow">
        <input type="text" name="quiz_question[options][]" id="option_${this.optionCounter}" 
               value="" placeholder="Enter answer option" 
               class="w-full rounded-lg border border-slate-300 dark:border-slate-600 bg-white/50 
                      dark:bg-slate-700/50 px-3 py-2 text-slate-900 dark:text-white shadow-sm 
                      focus:border-indigo-500 focus:ring-indigo-500">
      </div>
      <button type="button" class="remove-option pt-2" data-action="click->quiz-question-form#removeOption" data-option="${this.optionCounter}">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-red-500 hover:text-red-700" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z" clip-rule="evenodd" />
        </svg>
      </button>
    `;

    this.optionsContainerTarget.appendChild(optionWrapper);
    this.optionCounter++;
  }

  removeOption(event) {
    const optionId = event.currentTarget.dataset.option;
    const optionElement = this.element.querySelector(
      `[data-option="${optionId}"]`
    );
    if (optionElement) {
      this.optionsContainerTarget.removeChild(optionElement);
    }
  }

  addInitialOptions() {
    // Add two initial options
    this.addOption();
    this.addOption();
  }
}
